module.exports = __webpack_public_path__ + "static/media/Monday_Step3_Image4.bd988419.webp";